import { Plugin } from '@nuxt/types';
import { rules, validators } from '~/utils/validation-rules';

declare module 'vue/types/vue' {
  interface Vue {
    $rules: typeof rules;
    $validators: typeof validators;
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $rules: typeof rules;
    $validators: typeof validators;
  }
  interface Context {
    $rules: typeof rules;
    $validators: typeof validators;
  }
}

const validationRulesPlugin: Plugin = (context, inject) => {
  inject('rules', rules);
  inject('validators', validators);

  context.$rules = rules;
  context.app.$rules = rules;
  context.$validators = validators;
  context.app.$validators = validators;
};

export default validationRulesPlugin;
